"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var defaults = {
  headline: null,
  avatar: null
};

var DisplayInfo = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(DisplayInfo, _Record);

  function DisplayInfo() {
    (0, _classCallCheck2.default)(this, DisplayInfo);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DisplayInfo).apply(this, arguments));
  }

  (0, _createClass2.default)(DisplayInfo, null, [{
    key: "from",
    value: function from(json) {
      return new DisplayInfo(json);
    }
  }]);
  return DisplayInfo;
}((0, _immutable.Record)(defaults));

exports.default = DisplayInfo;
module.exports = exports.default;